import { render, staticRenderFns } from "./LegacyMain.vue?vue&type=template&id=5388c26c&"
import script from "./LegacyMain.vue?vue&type=script&lang=js&"
export * from "./LegacyMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports